import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var usePostOfferTestCalculations = function () {
    return useApiCall(function (signal, payload) { return api.calculator.apiCalculatorPost(payload, { signal: signal }); }, null, true, [], { success: 'Calculation done' });
};
